import React from 'react';
import {Card, CardBody, CardHeader, Table} from 'reactstrap';
import BoxesItem from './BoxesItem';

class BoxesList extends React.Component {
    render() {
        const {boxes} = this.props;

        return (
            <Card className="BoxesList">
                <CardHeader>
                    <h4 className="w-100 font-weight-bold mb-3">Danh sách thùng hàng</h4>
                </CardHeader>
                <CardBody>
                    <Table responsive>
                        <thead>
                        <tr>
                            <th>ID</th>
                            <th>Thời gian tạo thùng</th>
                            <th>Thời gian đóng thùng</th>
                            <th>Hành động</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            boxes.map((box, index) => {
                                return <BoxesItem key={index} box={box}/>;
                            })
                        }
                        </tbody>
                    </Table>
                </CardBody>
            </Card>
        );
    }
}

export default BoxesList;
